<template>
    <TopNav></TopNav>
    <h1>Калькулятор відсотків</h1>
    <fieldset>
        <legend>Калькулятор відсотків</legend>
        Що таке <input type="number" v-model.number="percentage" id="a" step="any">% від <input type="number" v-model.number="theNumber" id="a" step="any">?
        <br><br>
        Результат: <span class="blue">{{ theResult() }}</span>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: "PercentageCalculator",
    data() {
        return {
            percentage: 10,
            theNumber: 100,
        }
    },
    components: {
        TopNav
    },
    methods: {
        theResult: function () {
            return this.theNumber * this.percentage / 100;
        },
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

.blue {
    color: #0063dc;
}

label {
    display: inline-block;
    width: 110px;
}

footer section a {
    margin: 20px;
}
</style>
